export default "__VITE_ASSET__5Pbj$OrK__"